import ActivityType from './ActivityType'
import Address from './Address'
import Basic from './Basic'
import DocumentIcon from './Document'
import Group from './Group'
import GroupsPermissions from './GroupsPermissions'
import OrganizationalUnit from './OrganizationalUnit'
import Place from './Place'
import PublicAgent from './PublicAgent'
import PublicAgentsPermissions from './PublicAgentsPermissions'
import System from './System'

const Icons = {
  ...ActivityType,
  ...Address,
  ...Basic,
  ...DocumentIcon,
  ...Group,
  ...GroupsPermissions,
  ...OrganizationalUnit,
  ...Place,
  ...PublicAgent,
  ...PublicAgentsPermissions,
  ...System,
}

export default Icons
